import axios from "axios";

export default function ScheduleShowService(scheduleGroupId, scheduleId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/schedule/" + scheduleGroupId + "/" + scheduleId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
